import { TJobOverviewPageRoutesLocationState } from './Types';
import { createUseSafeLocationState } from '~/utils/SafeLocationState';

export const useSafeLocationState = createUseSafeLocationState<TJobOverviewPageRoutesLocationState>(
  {
    fromOnsiteInterviewCreation: false,
    startCloseJobFlow: false,
  },
);
